import React from "react";
import { FieldProps } from "./types";
import getIn from "helpers/getIn";

interface TextProps extends FieldProps {}

const TextField: React.FC<TextProps> = ({ source, record }) => {
    const safeRecord = record && typeof record === "object" ? (record as object) : {};
    const value = source && getIn(safeRecord, source);
    if (value === undefined || value === null) {
        return <span />;
    }

    if (typeof value === "string") {
        return <span>{value}</span>;
    }

    if (
        typeof value === "number" ||
        typeof value === "bigint" ||
        typeof value === "boolean" ||
        value instanceof Date
    ) {
        return <span>{String(value)}</span>;
    }

    return <span>{JSON.stringify(value)}</span>;
};

export default TextField;
